<div class="d-flex flex-column">
    <div class="scss-custom-thank-you-card">
        <div class="d-flex justify-content-center padding-y-16" [ngClass]="{'padding-x-32': !isMobile , 'padding-x-16': isMobile}">
            <div [innerHTML]="(thankYouMessage ?? '') | trustHtml" libRunScripts></div>
        </div>
    </div>

    @if (students.length) {
        <div [ngClass]="{'padding-x-32': !isMobile , 'padding-x-16': isMobile}">
            <div *ngFor="let student of students" class="mt-3 scss-thank-you-student-detail">
                <div class="d-flex row align-items-center padding-y-16 padding-x-14 ">
                    <div [ngClass]="{'col-6': !isMobile , 'col-12': isMobile}">
                        <div class="d-flex gap-3">
                            @if (student.IsAdult && !student.IsAdditionalStudent) {
                                <ng-container *ngTemplateOutlet="primaryContactAvatar; context:{$implicit:parent}"></ng-container>
                            } @else {
                                <div class="rounded-circle d-flex align-items-center justify-content-center scss-sign-up-avatar background-brand" style="height: 36px; width: 36px;">
                                    {{student.FirstName! | method:GetInitial | uppercase}}
                                </div>
                            }
                            <div class="d-flex flex-column">
                                <p class="typography-label-large-strong base-200">
                                    {{student.FirstName}} {{student.LastName}}
                                </p>
                                <div class="d-flex gap-2">
                                    <p class="typography-body-small neutral-800" i18n="@@CommonStudent">#Student#</p>
                                    @if (student.IsAdult && !student.IsAdditionalStudent) {
                                        <!-- eslint-disable-next-line -->
                                        <p class="typography-body-small neutral-800">•</p>
                                        <p class="typography-body-small neutral-800" i18n="@@CommonSignUpWidgetPrimaryContactLabel">Primary Contact</p>
                                    } @else if (!student.IsAdult) {
                                        <!-- eslint-disable-next-line -->
                                        <p class="typography-body-small neutral-800">•</p>
                                        <p class="typography-body-small neutral-800" i18n="@@CommonStudentsAddStudentIsChildStudent">Child</p>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    @if (!student.IsAdult || student.IsAdditionalStudent) {
                        <div [ngClass]="{'col-6': !isMobile , 'col-12': isMobile}" data-clarity-mask="true">
                            @if (student.EmailAddress) {
                                <lib-icon-bullet class="d-flex"
                                    [icon]="Icon.Common.MailOutline">
                                    {{student.EmailAddress}}
                                </lib-icon-bullet>
                            }
                        </div>
                    } @else {
                        <div [ngClass]="{'col-6': !isMobile , 'col-12 pt-2': isMobile}">
                            <ng-container *ngTemplateOutlet="parentPhoneNumbers; context:{$implicit:parent}"></ng-container>
                        </div>
                    }
                </div>
                @if (student.BookingRequest) {
                    <div class="d-flex flex-column gap-3 padding-y-16 padding-x-14 border-top">
                        <div class="d-flex justify-content-between">
                            <p class="typography-label-medium-strong" i18n="@@CommonBookedLessonLabel">Booked #Lesson#</p>
                            <lib-icon [icon]="Icon.Calendar.CalendarAdd" [size]="IconSize.Small"></lib-icon>
                        </div>
                        <div class="d-flex gap-1 flex-wrap">
                            <lib-status-label [kind]="StatusKind.Light" [icon]="Icon.Common.PersonVoiceOver">
                                <ng-container label>
                                    @if (student.BookingRequest.Teacher) {
                                        <span data-clarity-mask="true">{{student.BookingRequest.Teacher.Name}}</span>
                                    }
                                    @if (!student.BookingRequest.Teacher) {
                                        <ng-container i18n="@@CommonCalendarNoTeacherOption">General Event - No #Teacher# Specified</ng-container>
                                    }
                                </ng-container>
                            </lib-status-label>
                            <lib-status-label [kind]="StatusKind.Light" [icon]="Icon.Common.Calendar">
                                <ng-container label>
                                    {{student.BookingRequest.StartDate | formatDate: 'long'}}
                                </ng-container>
                            </lib-status-label>
                            <lib-status-label [kind]="StatusKind.Light" [icon]="Icon.Common.Time">
                                <ng-container label>
                                    {{student.BookingRequest.StartDate| formatTime: 'short'}} - {{student.BookingRequest.EndDate | formatTime: 'short'}}
                                </ng-container>
                            </lib-status-label>
                            @if (student.BookingRequest.SubjectTagID) {
                                <lib-status-label
                                    [kind]="StatusKind.Light"
                                    [icon]="Icon.Common.LabelTag">
                                    <ng-container label>
                                        {{ subjectTagByID[student.BookingRequest.SubjectTagID].Name }}
                                    </ng-container>
                                </lib-status-label>
                            } @else {
                                <lib-status-label
                                    [kind]="StatusKind.Custom"
                                    [icon]="subjectIcon"
                                    [labelColor]="student.BookingRequest.EventCategory!.Color| method: BackgroundColorClass">
                                    <ng-container label>
                                        {{ student.BookingRequest.EventCategory!.Name }}
                                    </ng-container>
                                </lib-status-label>
                            }
                            @if (student.BookingRequest.EventLocation) {
                                <lib-status-label [kind]="StatusKind.Custom"
                                    [icon]="student.BookingRequest.EventLocation.Icon! | calendarEventLocationIcon" [labelColor]="student.BookingRequest.EventLocation.Color | method: BackgroundColorClass">
                                    <ng-container label>
                                        {{student.BookingRequest.EventLocation.Name}}
                                    </ng-container>
                                </lib-status-label>
                            }
                        </div>
                    </div>
                }
            </div>
            @if (!isParentAStudent) {
                <div class="padding-y-16 padding-x-14 mt-3 scss-thank-you-student-detail">
                    <div class="d-flex row align-items-center">
                        <div [ngClass]="{'col-6': !isMobile , 'col-12': isMobile}">
                            <div class="d-flex gap-3">
                                <ng-container *ngTemplateOutlet="primaryContactAvatar; context:{$implicit:parent}"></ng-container>
                                <div class="d-flex flex-column">
                                    <p class="typography-label-large-strong base-200">
                                        {{parent.FirstName}} {{parent.LastName}}
                                    </p>
                                    <p class="typography-body-small neutral-800" i18n="@@TPSignUpWidgetPrimaryContactLabel">Primary Contact</p>
                                </div>
                            </div>
                        </div>
                        <div [ngClass]="{'col-6': !isMobile , 'col-12 pt-2': isMobile}">
                            <ng-container *ngTemplateOutlet="parentPhoneNumbers; context:{$implicit:parent}"></ng-container>
                        </div>
                    </div>
                </div>
            }
        </div>

        <lib-submission-bar
            [kind]="SubmissionBarKind.WidgetBasic">
            <lib-button
            [role]="ButtonRole.Primary"
            [size]="ButtonSize.Large"
                (clicked)="DoneClicked()">
                    <ng-container label i18n="@@CommonDoneButtonLabel">Done</ng-container>
            </lib-button>
            <lib-button
            [role]="ButtonRole.Secondary"
                [kind]="ButtonKind.Secondary"
                [size]="ButtonSize.Large"
                (clicked)="AddStudentClicked()">
                    <ng-container label i18n="@@CommonAddStudentButtonLabel">Add #Student#</ng-container>
            </lib-button>
        </lib-submission-bar>
    }

</div>

<ng-template #parentPhoneNumbers let-parent>
    <div class="d-flex flex-column gap-2" [ngClass]="{'padding-left-50': isMobile}" data-clarity-mask="true">
        @if (parent.EmailAddress) {
            <lib-icon-bullet class="d-flex" [size]="IconSize.TwoExtraSmall" [icon]="Icon.Common.MailOutline">
                <p class="typography-body-small">{{parent.EmailAddress}}</p>
            </lib-icon-bullet>
        }
        @if (parent.TelephoneNumberHome) {
            <lib-icon-bullet class="d-flex" [size]="IconSize.TwoExtraSmall" [icon]="Icon.Common.OldPhoneOutline">
                <p class="typography-body-small">{{parent.TelephoneNumberHome}}</p>
            </lib-icon-bullet>
        }
        @if (parent.TelephoneNumberMobile) {
            <lib-icon-bullet class="d-flex" [size]="IconSize.TwoExtraSmall" [icon]="Icon.Common.PhoneAltOutline">
                <p class="typography-body-small">{{parent.TelephoneNumberMobile}}</p>
            </lib-icon-bullet>
        }
    </div>
</ng-template>

<ng-template #primaryContactAvatar let-parent>
    <div class="rounded-circle d-flex align-items-center justify-content-center scss-sign-up-avatar background-brand position-relative" style="height: 36px; width: 36px;">
        {{parent.FirstName! | method:GetInitial | uppercase}}
        <div class="position-absolute end-0 rounded-circle background-base-0" style="height: 16px; width: 16px; top:-3px">
            <lib-icon class="scss-sign-up-avatar-icon-colour justify-content-center" [icon]="Icon.Common.Star" [size]="IconSize.TwoExtraSmall"></lib-icon>
        </div>
    </div>
</ng-template>